import * as React from "react";
import FileReceipt from "./FileReceipt";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FileReceiptGridReducerAction } from "../Store/FileReceiptGridReducer";

export default function FileReceiptView() {
  //Creating Dispatch
  const dispatch = useDispatch();

  const screenMode = useSelector((state) => state.fileReceiptGrid.screenMode);

  useEffect(() => {
    if (screenMode !== null && screenMode !== undefined && screenMode === "") {
      dispatch(FileReceiptGridReducerAction.updateScreenMode("VIEW"));
    }
  }, [screenMode]);

  return (
    <React.Fragment>
      <FileReceipt
        mode={screenMode}
        screenTitle={screenMode === "VIEW" ? "Receipt View" : "Receipt Modify"}
      />
    </React.Fragment>
  );
}
